import { AfterViewInit, Component, EventEmitter, Input, Output,
       } from '@angular/core';

import { FontInjectorService } from 'collage-designer/font-injector.service';
import { FontStoreService } from 'core/fontstore/fontstore.service';

@Component({
  selector: 'font-chooser',
  templateUrl: './font-chooser.component.html',
  styleUrls: [ './font-chooser.component.scss' ],
})
export class FontChooserComponent implements AfterViewInit
{
  @Input() public set fontName(value: string)
  {
    this._fontName = value;
    this.displayFontName = value.replace(/"/g, '');
  }

  public get fontName(): string
  {
    return this._fontName;
  }

  @Output() public fontNameChange: EventEmitter<string> =
    new EventEmitter;

  public displayFontName: string;
  public availableFonts: Array<string> = [];
  private _fontName: string = '';

  constructor(
    private fontStoreService: FontStoreService,
    private fontInjectorService: FontInjectorService
  )
  {}

  public ngAfterViewInit(): void
  {
    this.updateAvailableFonts();
  }

  private async updateAvailableFonts(): Promise<void>
  {
    this.availableFonts = await this.fontInjectorService.getFontList();
  }

  public async setFontName(value: string): Promise<void>
  {
    try {
      await this.fontInjectorService.addFont(value);
    }
    catch (e) {
      this.fontInjectorService.buildFontLoadingError(e, 'FontChooserComponent');
      this.fontNameChange.emit(this.fontName);
      return;
    }

    this.fontNameChange.emit(value);
  }

  public fontPreviewBackground(fontName: string): any
  {
    return {
      'background-image':
          'url("' + this.fontStoreService.getFontPreviewUrl(fontName) + '")'
    };
  }

  public get selectedFontStyle(): any
  {
    return {
      'font-family': this._fontName,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/controls/font-chooser/font-chooser.component.ts